export class SpecialPrice {
    amount: number | undefined;
    startDate: string | undefined;
    endDate: string | undefined;

    constructor(
        amount: number | undefined = undefined,
        startDate: string | undefined = undefined,
        endDate: string | undefined = undefined,
    ) {
        this.amount = amount;
        this.startDate = startDate;
        this.endDate = endDate;
    }

    public static copy(destination: SpecialPrice | undefined, source: SpecialPrice): SpecialPrice {
        if (!destination) {
            destination = new SpecialPrice();
        }
        if (source) {
            if (destination.amount != source.amount) destination.amount = source.amount;
            if (destination.startDate != source.startDate) destination.startDate = source.startDate;
            if (destination.endDate != source.endDate) destination.endDate = source.endDate;
        }

        return destination;
    }
}